import { useState, useEffect, useCallback, useRef } from 'react'

function useLocation() {
  const [lokacija, setLokacija] = useState(null)
  const [klaida, setKlaida] = useState(null)
  const [kraunasi, setKraunasi] = useState(true)
  const lokacijaRef = useRef(null)

  const patikrinti = useCallback(() => {
    if (!navigator.geolocation) {
      setKlaida('Tavo naršyklė nepalaiko GPS')
      setKraunasi(false)
      return
    }
    setKraunasi(true)
    setKlaida(null)
    // ⚠️ 2026-09-22: buvo timeout 8000 be pakartojimo. Telefone lauke ar patalpoje
    // pirmas GPS taškas dažnai užtrunka ilgiau, tad lokacija likdavo null —
    // o tada atstumo filtras TYLIAI dingdavo ir ruletė mesdavo Nidą „už 70 km".
    // Dabar: greitas apytikslis taškas, ilgesnis laukimas ir vienas pakartojimas.
    const pavyko = (pozicija) => {
      const vieta = { lat: pozicija.coords.latitude, lng: pozicija.coords.longitude }
      lokacijaRef.current = vieta
      setLokacija(vieta)
      setKlaida(null)
      setKraunasi(false)
    }
    const nepavyko = () => {
      setKlaida('Nepavyko gauti lokacijos — patikrink leidimus')
      setKraunasi(false)
    }

    navigator.geolocation.getCurrentPosition(
      pavyko,
      () => {
        // Antras bandymas — dar kantresnis, priima ir senesnį tašką
        navigator.geolocation.getCurrentPosition(
          pavyko,
          nepavyko,
          { enableHighAccuracy: false, timeout: 25000, maximumAge: 600000 }
        )
      },
      { enableHighAccuracy: false, timeout: 20000, maximumAge: 120000 }
    )
  }, [])

  useEffect(() => {
    // Užklausiam užsikrovus (native leidimo langas, jei dar neapsispręsta)
    patikrinti()

    // Grįžus į programėlę (pvz. iš nustatymų), jei lokacijos vis dar nėra —
    // užklausiam iš naujo. Taip po leidimo įjungimo app iškart pasitikrina.
    const grizus = () => {
      if (document.visibilityState === 'visible' && !lokacijaRef.current) {
        patikrinti()
      }
    }
    document.addEventListener('visibilitychange', grizus)
    return () => document.removeEventListener('visibilitychange', grizus)
  }, [patikrinti])

  return { lokacija, klaida, kraunasi, patikrinti }
}

export default useLocation
